import React, { useRef } from "react";
import { html } from "@codemirror/lang-html";
import Editor from "./boxComponents/Editor";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquareCaretLeft, faSquareCaretRight, faSquareCaretUp, faSquareCaretDown } from "@fortawesome/free-solid-svg-icons";


const HTMLBox = ({ cStyle, icon, value, codeFunction, cWidth, onHandleClick, toggle, viewPosition }) => {
    const [toggle1, toggle2, toggle3] = toggle;
    const boxref = useRef();
    // const [divWidth, setDivWidth] = useState(null);

    const divStyle = {
        ...cStyle[0],
        width: viewPosition ? "100%" : cWidth[0] ? `${cWidth[0]}px` : cStyle[0].width,
        height: viewPosition && cWidth[0] ? `${cWidth[0]}px` : cStyle[0].height,
        icon: {
            color: "rgb(255, 60, 65)"
        },
        boxStyle: !toggle2 && !toggle3 ? { ...cStyle[1] } : viewPosition ? { ...cStyle[1] } : { ...cStyle[2] }
    };

    return (
        <div style={divStyle} id="html" ref={boxref}>
            <div style={divStyle.boxStyle}>
                <div style={divStyle.boxStyle.textDiv}>
                    <FontAwesomeIcon icon={icon} style={divStyle.icon} />

                    {toggle2 === true || toggle3 === true ? null : <h3 style={divStyle.boxStyle.h3}>html</h3>}
                </div>

                <FontAwesomeIcon icon={viewPosition ? toggle1 ? faSquareCaretDown : faSquareCaretUp : toggle1 ? faSquareCaretLeft : faSquareCaretRight} style={divStyle.boxStyle.button} onClick={onHandleClick} />
            </div>
            <Editor onChange={codeFunction} language={html} value={value} />
        </div>
    );
}

export default HTMLBox;